import styled from 'styled-components/macro';
import { FONTS, FLEX_CONTAINER, COLORS, BREAKPOINTS } from 'utils/styles';

export const StyledUserNameContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  grid-gap: 14px;
  cursor: pointer;
`;

export const StyledImageContainer = styled.div`
  width: 44px;
  height: 44px;
  background-image: ${({ src }) => `url(${src})`};
  background-position: center;
  background-size: contain;
  border-radius: 100%;
`;

export const StyledUserName = styled.div`
  color: ${COLORS.mainColor};
  ${FONTS.font14}

  @media only screen and ${BREAKPOINTS.md} {
    display: none;
  };
`;
